import { useEffect } from "react"
import { useProfileStore } from "./profileStore"
import { useShallow } from "zustand/react/shallow"

export const ProfileInitializer = ({ children }) => {
    const { favorites, profileData, hasOnboarded, hasAllowedCookies } =
        useProfileStore(
            useShallow((state) => ({
                favorites: state.favorites,
                profileData: state.profileData,
                hasOnboarded: state.hasOnboarded,
                hasAllowedCookies: state.hasAllowedCookies,
            })),
        )

    useEffect(() => {
        if (hasAllowedCookies) {
            localStorage.setItem("favorites", JSON.stringify(favorites))
            localStorage.setItem("profileData", JSON.stringify(profileData))
            localStorage.setItem("hasOnboarded", hasOnboarded.toString())
        }
    }, [favorites, hasAllowedCookies, hasOnboarded, profileData])

    useEffect(() => {
        if (!hasAllowedCookies) {
            localStorage.clear()
        }
    }, [hasAllowedCookies])

    return <>{children}</>
}
